export const getVoterId = () => {
  let v = localStorage.getItem("vr_voter_id");
  if (!v) {
    v = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`);
    localStorage.setItem("vr_voter_id", v);
  }
  return v;
};
